import styled from 'styled-components';
import SahamDialog from 'components/SahamDialog';

export const Container = styled.div`
  width: 100%;
  .left-icon {
    width: 14px;
    margin-right: 17px;
    color: #323e48;
  }
  .right-icon {
    width: 14px;
    margin-left: 17px;
    fill: #fff;
  }
  .support-document-info {
    margin: 20px;
  }
  .add-recap-bloc {
    background-color: #ffffff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    padding: 24px;
    display: grid;
  }
  .add-recap-bloc-title {
    color: #2b2727;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 24px;
  }
`;

export const ExpertReportDecisionDialogWrapper = styled(SahamDialog)`
  display: flex;
  flex-direction: column;
  .contest-wrapper {
    margin: 5px;
  }
  .reason-wrapper {
    padding: 9px 0px;
  }
  &.refusal-content {
    min-width: 500px;
    min-height: 30vh;
  }

  .contest-wrapper > * {
    margin: 9px 0px;
  }

  .upload-document {
    margin: 15px 0;
  }
  .upload-doc-title {
    font-size: 14px;
    font-weight: bold;
    color: #2b2727;
  }
  .upload-document-button {
    margin-top: 16px;
    font-weight: normal;
    font-size: 14px;
    padding: 10px;
    min-width: 220px;
  }
  .cloud-icon {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
`;
